module.exports = __webpack_public_path__ + "static/img/future3.0bb40678.png";